/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Legal_Entity_DeleteInputs */

const cs_settings_office_legal_entity_delete = /** @type {(inputs: Settings_Office_Legal_Entity_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smazat firmu`)
};

const en_settings_office_legal_entity_delete = /** @type {(inputs: Settings_Office_Legal_Entity_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete company`)
};

/**
* | output |
* | --- |
* | "Delete company" |
*
* @param {Settings_Office_Legal_Entity_DeleteInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_legal_entity_delete = /** @type {((inputs?: Settings_Office_Legal_Entity_DeleteInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Legal_Entity_DeleteInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_legal_entity_delete(inputs)
	return cs_settings_office_legal_entity_delete(inputs)
});